import { render, staticRenderFns } from "./Tmpl.vue?vue&type=template&id=0bae73bc"
import script from "./Tmpl.vue?vue&type=script&lang=js"
export * from "./Tmpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports